import React, { useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useIsMobile } from "../../hooks/useIsMobile";
import { peopleOfSeekho } from "../../utils/constants/Team";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import Quote from "../Icons/LandingPage/Quote";
import Fade from "react-reveal/Fade";
import CustomNextImage from "../common/CustomNextImage";

const PeopleOfSeekho = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { isMobile } = useIsMobile();
  const repeatCount = isMobile ? 1 : 3;
  const repeatedUsers = Array(repeatCount).fill(peopleOfSeekho).flat();
  return (
    <section>
      <Fade bottom>
        <h6 className="text-[24px] font-lexend font-semibold text-center lg:text-[40px]">
          People Of Seekho
        </h6>
      </Fade>
      <Swiper
        centeredSlides={true}
        loop={true}
        slidesPerView={"auto"}
        initialSlide={1}
        autoplay={{
          delay: 7000,
          disableOnInteraction: false,
        }}
        pagination={true}
        navigation={!isMobile}
        modules={[Autoplay, Pagination, Navigation]}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        onSwiper={(swiper) => setActiveIndex(swiper.realIndex)}
        className="!mt-6 lg:!mt-10"
      >
        {repeatedUsers?.map((data, index) => {
          const isActive =
            index % peopleOfSeekho.length ===
            activeIndex % peopleOfSeekho.length;
          return (
            <SwiperSlide
              key={index}
              className={`!w-[90%] relative z-[9999] transition-all duration-500 ml-4 mr-4 md:ml-2 md:!w-[550px] md:!h-[280px] lg:!w-[660px] lg:!h-[308px] lg:ml-10 ${
                isActive ? "opacity-100 scale-100" : "opacity-50 scale-95"
              }`}
            >
              <div className="bg-gradient-to-r from-[#330030] to-[#180a2b] !border !border-[#634969] rounded-2xl py-3 px-3 text-white shadow-lg h-full flex flex-col justify-between lg:py-6 lg:px-6">
                <Quote className="!w-[32px] !h-[32px]" />
                <p className="m-0 p-0 text-[12px] italic leading-[20px] mt-3 md:not-italic md:mt-4 md:text-[14px] md:font-lexend lg:mt-6 lg:text-[16px] lg:leading-[20px] lg:text-[#b8b8b8]">
                  {data?.desc}
                </p>

                <div className="flex items-center gap-x-4 !mt-1 lg:!mt-4">
                  <div className="!h-[2px] w-full !border !border-dashed border-white/15"></div>
                  <Quote className="!w-[32px] h-[32px] rotate-180" />
                </div>

                <div className="flex items-center gap-x-3 mt-2 lg:mt-4 lg:gap-x-3">
                  <CustomNextImage
                    src={data?.image}
                    alt={data?.name}
                    width={100}
                    height={100}
                    className="w-[48px] h-[48px] rounded-full object-cover border border-white md:w-[56px] md:h-[56px] lg:w-[64px] lg:h-[64px]"
                  />
                  <div>
                    <p className="font-medium font-lexend text-[14px] p-0 m-0 lg:text-[24px]">
                      {data?.name}
                    </p>
                    <p className="text-gray-300 p-0 m-0 text-[12px] font-lexend opacity-80 lg:text-[16px]">
                      {data?.designation}
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default PeopleOfSeekho;
